import { FIELD_TYPES_WITH_FORMULA, FieldType, FieldTypeChanges } from "@dto/fields";

/** Types sharing the same numeric storage: the display format stays meaningful between them */
export const NUMERIC_FAMILY: FieldType[] = [FieldType.Number, FieldType.Decimal, FieldType.Devise, FieldType.Percent];
/** Types sharing the same text storage */
export const TEXT_FAMILY: FieldType[] = [FieldType.Text, FieldType.TextArea, FieldType.Url];
/** Types sharing the same choice options (type items) */
export const CHOICE_FAMILY: FieldType[] = [FieldType.Choice, FieldType.MultiChoice];

function sameFamily(from: FieldType, to: FieldType, family: FieldType[]): boolean {
  return family.includes(from) && family.includes(to);
}

/** Whether the type items (choice options, period type...) of the field remain valid after the type change */
export function keepsTypeItems(from: FieldType, to: FieldType): boolean {
  return from === to || sameFamily(from, to, CHOICE_FAMILY);
}

/** Whether the display format of the field remains valid after the type change */
export function keepsFormat(from: FieldType, to: FieldType): boolean {
  return from === to || sameFamily(from, to, NUMERIC_FAMILY) || sameFamily(from, to, TEXT_FAMILY);
}

/** Whether the formula of the field remains meaningful after the type change: only some types accept a formula */
export function keepsFormula(to: FieldType | undefined): boolean {
  return to !== undefined && FIELD_TYPES_WITH_FORMULA.includes(to);
}

/**
 * Whether a type can be selected in the update dialog: the current type always, the others when the backend
 * allows the change. Nothing else is selectable while the backend answer is unknown, and a link field never changes.
 * Types needing a conversion of the stored values (changes.convertible) are not selectable for now.
 */
export function isTypeSelectable(type: FieldType, currentType: FieldType, changes: FieldTypeChanges | null | undefined): boolean {
  if (type === currentType) {
    return true;
  }
  if (type === FieldType.Link || currentType === FieldType.Link || !changes) {
    return false;
  }
  return changes.allowed.includes(type);
}
